import { createContext } from 'react';
import { Document } from '../../models/Document';

type DocumentsContextProps = {
  documents: Document[];
  setDocuments: React.Dispatch<React.SetStateAction<Document[]>>;
  downloadDocument: (doc: Document) => void;
};

export default createContext<DocumentsContextProps>({
  documents: [],
  setDocuments: () => {},
  downloadDocument: () => {},
});
